
// // http://www.skhystec.com/service-cafe-ic.asp?
// // m_gubun1=4&
// // shr_yymmdd=2020-01-02
import { ApiService } from "@/services/GuneApiService.js";


export default async function (restaurant, yyyymmdd) {
        if (restaurant.ext_grp ==4){
            await ApiService().get(`/parser/${restaurant.ext_grp}/${yyyymmdd}/`)
        
            return
        }


        return null;
    }


